export type SpecRow = {
  label: string;
  value: string;
};

type SpecTableProps = {
  title?: string;
  rows: SpecRow[];
  dark?: boolean;
};

export default function SpecTable({ title, rows, dark = false }: SpecTableProps) {
  return (
    <div>
      {title && (
        <h3
          className={`text-ink font-serif text-xl md:text-2xl font-semibold mb-4 ${
            dark ? "text-cream" : "text-ink"
          }`}
        >
          {title}
        </h3>
      )}
      <div className="overflow-x-auto">
        <table className="w-full min-w-[340px] border-collapse">
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.label}
                className={
                  dark
                    ? "border-b border-cream/10 last:border-0"
                    : "border-b border-cream-dark/40 last:border-0"
                }
              >
                <td
                  className={`py-2.5 pr-4 text-sm align-top whitespace-nowrap ${
                    dark ? "text-cream/60" : "text-ink/60"
                  }`}
                >
                  {row.label}
                </td>
                <td
                  className={`py-2.5 text-sm font-mono text-right align-top ${
                    dark ? "text-cream" : "text-ink"
                  }`}
                >
                  {row.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}